import {ref} from 'vue'
import axios from 'axios'
import {log} from "@/composables/useLog"
import {BASE_URL} from "@/composables/url_config";
  const error = ref(null)
export const addNewService = async (token, form) => {
    log("welcome in addNewService cu parametrii " )
    log("token")
    log(token)
    const API_URL =`${BASE_URL}/home/addNewServiceApi`;
    error.value = null
    try {
        error.value = null
        const headers= {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${token}`
        }

        const params = form;
        const result = await axios.post(API_URL, params, { headers });
        log("parameters data send:")
        log(params)
        error.value = null
        log ("result.data=");
        log (result.data);
        if(result.data.error==true){
            alert(result.data.message)
        }
        return result.data
    } catch (err){
        log("am intrat pe la catch (err) in addNewService")
        log(err.value)
        error.value=err.value
    }
}

const useAddNewService = () => {
        return { addNewService };
}
export default useAddNewService
